<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
// import { news } from "./data";
import Heading from "../../layouts/heading";
import PcnCard from "@/components/cards/PcnCard";
import NewsCard from "@/components/cards/NewsCard";
import api from "../../../api";

export default {
  props: {
    category: {},
  },
  page: {
    title: "View All",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Heading, PcnCard, NewsCard },
  data() {
    return {
      items: null,
      pageSize: 16,
      pageNumber: 1,
      formData: {},
      page: {
        title: '',
        lastUpdated: '31 Dec 2020 15:00',
        addNewBtn: false,
        formData: {},
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false
      }, 
      submitted: false,
      form: {
        message: "",
      },
      categoryName: null
    };
  },
  computed: {
    itemsArray() {
      if (!this.items) return []
      return this.items.slice(this.pageSize * this.pageNumber - this.pageSize, this.pageSize * this.pageNumber)
    },
    cardType() {
      switch(this.categoryName) {
        case 'News':
          return 'news'
        case 'Meeting & Events':
          return 'event'
        case 'Videos':
          return 'video'
        default:
          return 'news'
      }
    }
  },
  methods: {
    async getItem() {
      try {
        const { data } = await api.get('/api/categories/'+this.$route.params.slug+'/pages')
        this.items = data.some(page => page.additionalProp1.position) ? data.sort((a, b) => a.additionalProp1.position - b.additionalProp1.position) : data
        console.log(this.items)
      } catch (error) {
        console.log(error)
      }
    },
    async getCategoryName() {
      const categoryItem = this.items.find(item => item.additionalProp1.categoryName)
      this.categoryName = categoryItem.additionalProp1.categoryName
      this.$set(this.page, 'title', this.categoryName)
    },
    onNewsClick(card) {
      console.log(card)
    },
    getChunksArray(inputArray, chunks) {
      const chunksArray = inputArray.reduce((resultArray, item, index) => { 
        const chunkIndex = Math.floor(index/chunks)
        if(!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []
        }
        resultArray[chunkIndex].push(item)
        return resultArray
      }, [])
      return chunksArray
    },
    setPageNumber(val) {
      this.pageNumber = val
    }
  },
  watch: {
    currentCms() {
      this.$router.push({ name: 'Pages' }).catch(()=>{});
    }
  },
  async mounted() {
    await this.getItem()
    this.getCategoryName()
  }
}
</script>
<template>
  <Layout>
    <Heading :page="page"></Heading>
    <div class="pl-page-container">
      <div class="items">
        <template v-for="card in itemsArray" >
          <PcnCard 
            v-if="categoryName !== 'News'"
            :key="card.id"
            :type="cardType"
            cardClass="m-0"
            :id="card.additionalProp1.id"
            :date="card.date || card.additionalProp1.date"
            :title="card.title"
            :text="card.description"
            :timeFrom="card.additionalProp1.start_time"
            :timeTo="card.additionalProp1.end_time"
            :media="cardType === 'event' ? false : true"
            :imageUrl="card.additionalProp1.imageUrl"
            :videoUrl="card.additionalProp1.video_url"
            @click="onNewsClick(card)"
          />
          <NewsCard 
            v-if="categoryName === 'News'"
            :key="card.id"
            cardClass="m-0"
            :id="card.additionalProp1.id"
            :date="card.date || card.additionalProp1.date"
            :title="card.title"
            :text="card.description"
            :imageUrl="card.additionalProp1.imageUrl"
            :videoUrl="card.additionalProp1.video_url"
            @click="onNewsClick(card)"
          />
        </template>
      </div>
      <el-pagination
        v-if="items.length"
        small
        layout="prev, pager, next"
        :page-size="16"
        :total="items.length"
        :background="false"
        @current-change="setPageNumber">
      </el-pagination>
    </div>
  </Layout>
</template>
<style lang="scss" scoped>
.items {
  display: grid;
  grid-template-columns: repeat(auto-fit, 288px);
  gap: 29px;
  padding-bottom: 40px;
  border-bottom: 1px solid #D2D6DE;
  margin-bottom: 30px;
}

</style>